export default __webpack_public_path__ + "static/media/img_shop-type01.8bec0d25.png";